import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
    addEditExchange,
    changeStatusExchange,
    changeStatusExchangeByCode,
    delExchange,
    getExchanges,
    removeApprovalExchange
} from '../../services';
import {IExchange, IExchangeFilter, IExchangeRes, IExchangeState} from "../types/IExchange";
import historyHelper from "../../helpers/history";
import {AppState} from "./rootReducer";
import {updateExchangeItem} from "./patientsReducer";
import {ESTADO_CANJE} from "../../helpers/CONSTANTES";

const initialState: IExchangeState = {
    status: "idle"
}

export const mostrarExchanges = createAsyncThunk(
    'mostrarExchanges', async (params:IExchangeFilter|undefined, thunkAPI ) => {
        const {exchanges} = thunkAPI.getState() as AppState;
        let paramsFilter = params || exchanges.filtered;

        const response = await getExchanges(paramsFilter)
        return {data: response.data as IExchangeRes, params: response.config.params}
    }
)

export const agregarEditarExchange = createAsyncThunk(
    'Exchanges/agregarEditar', async (exchange: IExchange, thunkAPI) => {
        const response = await addEditExchange(exchange);
        if ((response.status === 200 || response.status === 204) && !!exchange.id) {
            historyHelper.back()
        }

        return {data: response.data, edit:!!exchange.id};
    }
);
export const mostrarExchangeById = createAsyncThunk(
    'mostrarExchangeById', async (id:number,thunkAPI) => {
        // let byId = (thunkAPI.getState() as AppState)?.exchanges?.list?.items?.find(c=>c.id === id);
        // if(byId){
        //     return {data: byId}
        // }

        const response = await getExchanges(id);
        return {data: response.data as IExchange}
    }
)

export const eliminarExchange = createAsyncThunk(
    'exchange/eliminar', async (id: number, thunkAPI) => {
        const response = await delExchange(id);


        let patientById = (thunkAPI.getState() as AppState)?.patients?.byId

        if (response.status === 200 || response.status === 204) {
            if(!!patientById?.id){
                thunkAPI.dispatch(updateExchangeItem({id, status: ESTADO_CANJE.inactiva}))
            }
            historyHelper.back()
        };


        return id;
    }
);
export const cambiarEstadoExchange = createAsyncThunk(
    'exchange/estado', async (param: IExchange, thunkAPI) => {
        const response = await changeStatusExchange(param);
        // if (response.status === 200 || response.status === 204) historyHelper.back();

        let patientById = (thunkAPI.getState() as AppState)?.patients?.byId


        if ((response.status === 200 || response.status === 204) && patientById?.id) {
            thunkAPI.dispatch(updateExchangeItem(response.data))
        }



        return response.data;
    }
);
export const cambiarEstadoExchangeByCode = createAsyncThunk(
    'exchangeByCode/estado', async (param: IExchange) => {
        const response = await changeStatusExchangeByCode(param);
        // if (response.status === 200 || response.status === 204) historyHelper.back();

        return response.data;
    }
);
export const deshacerAprobacionExchange  = createAsyncThunk(
    'exchange/DeshacerAprobacion', async (id: number, thunkAPI) => {
         await removeApprovalExchange(id);

        return {id, status: ESTADO_CANJE.pendiente};
    }
);

const slice = createSlice({
    name: 'mostrarExchanges',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarExchanges
        builder.addCase(mostrarExchanges.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarExchanges.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarExchanges.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarEditarExchange
        builder.addCase(agregarEditarExchange.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarExchange.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
                if(!action.payload.edit){
                    ++state.list.pageSize
                    ++state.list.totalCount
                }

            }
        })
        builder.addCase(agregarEditarExchange.rejected, (state ) => {
            state.status = "idle";
        })
        //--mostrarExchangeById
        builder.addCase(mostrarExchangeById.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarExchangeById.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = action.payload.data;
        })
        builder.addCase(mostrarExchangeById.rejected, (state ) => {
            state.status = "idle";
        })

        //--eliminarExchange
        builder.addCase(eliminarExchange.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarExchange.fulfilled, (state,action ) => {
            state.status = "idle";
            const id = action.payload;
            if(state.list?.items){
                state.list.items = state.list?.items.filter(e => e.id !== id)
            }
        })
        builder.addCase(eliminarExchange.rejected, (state ) => {
            state.status = "idle";
        })
        //--cambiarEstadoExchange
        builder.addCase(cambiarEstadoExchange.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(cambiarEstadoExchange.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list.items.map(item=>{
                    if(item.id === action.payload?.id){
                        return {...item, ...action.payload}
                    }
                    return item
                })
            }
        })
        builder.addCase(cambiarEstadoExchange.rejected, (state ) => {
            state.status = "idle";
        })
        //--cambiarEstadoExchangeByCode
        builder.addCase(cambiarEstadoExchangeByCode.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(cambiarEstadoExchangeByCode.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list.items.map(item=>{
                    if(item.id === action.payload?.id){
                        return {...item, ...action.payload}
                    }
                    return item
                })
            }
        })
        builder.addCase(cambiarEstadoExchangeByCode.rejected, (state ) => {
            state.status = "idle";
        })
        //--deshacerAprobacionExchange
        builder.addCase(deshacerAprobacionExchange.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(deshacerAprobacionExchange.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list.items.map(item=>{
                    if(item.id === action.payload?.id){
                        return {...item, ...action.payload}
                    }
                    return item
                })
            }
        })
        builder.addCase(deshacerAprobacionExchange.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export default slice.reducer;
